import {AdminUpdateSchoolForm} from './AdminUpdateSchoolForm';

export default AdminUpdateSchoolForm;
